import styled from "styled-components";
import { Row } from "react-bootstrap";

export const RowGroup = styled<any>(Row)`
  margin: 0.5rem 0;
`;
